export interface WmsStyleModel {
  name: string;
  title?: string;
  abstractText?: string;
  legendUrl?: string;
}
